import React from 'react';

import LiveView from '../components/live_view/liveView';

const LiveViewAppClient = (props) => <LiveView {...props} />;

export default LiveViewAppClient;
